export default "__VITE_ASSET__NKbL$fT6__"